// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/@kmijs+bundler-compiled@0.0.8/node_modules/@kmijs/bundler-compiled/compiled/css-loader/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/@kmijs+bundler-compiled@0.0.8/node_modules/@kmijs/bundler-compiled/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".marginLeft_8___JGPuz {\n  margin-left: 8rem;\n}\n.marginLeft_4___YD0uF {\n  margin-left: 4rem;\n}\n", "",{"version":3,"sources":["webpack://./../../features/mpc-common/src/features/OvertimeTag/index.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AAEA;EACE,iBAAA;AAAF","sourcesContent":[".marginLeft_8 {\n  margin-left: 8px;\n}\n\n.marginLeft_4 {\n  margin-left: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"marginLeft_8": "marginLeft_8___JGPuz",
	"marginLeft_4": "marginLeft_4___YD0uF"
};
export default ___CSS_LOADER_EXPORT___;
